import { render, staticRenderFns } from "./AlternativeLocation.vue?vue&type=template&id=435f5d5a"
import script from "./AlternativeLocation.vue?vue&type=script&lang=js"
export * from "./AlternativeLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports